<!--- COMPONENTE UCElementoDeProduccion  ---->
<!---
Descripción del componente:
---------------------------
- Incluye un input que permite buscar por unidad logistica, partida y código de barras.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->

<template>
  <div class="div-componenteUCElementoDeProduccion">
    <UCCodeScanner
      :allow-manual-code-entry="true"
      :auto-open-camera="true"
      @code-reading="CodeScannerRead"
      @codigo-barras="CodeScannerRead"
    />
    <!-- BUSQUEDA CODIGO DE BARRAS -->
    <div v-show="readingMode === modosLectura.CODIGO">
      <p v-show="mostrarTitulo">
        {{ $t('production.productionElement.searchByCode.title') }}
      </p>
      <form
        class="from-busquedas"
        @submit.prevent="validarCodigo"
      >
        <f7-row class="">
          <f7-col width="20">
            <div class="div-modoInput">
              <div
                class="div-btnModoInput"
                @click="modoLectura = modosLectura.UNIDAD_CONTENEDORA"
              >
                <img
                  class="img-btnModoInput"
                  alt="iconCode"
                  src="@/static/icons/ic_code.svg"
                >
              </div>
            </div>
            <div class="div-btnInformacionCambioCirculo">
              <img
                class="img-btnCambioModo"
                alt="iconChange"
                src="@/static/icons/ic_exchange_arrows.svg"
                width="18"
                height="18"
              >
            </div>
          </f7-col>
          <f7-col width="80">
            <div class="div-campoDeEntrada">
              <input
                id="input-busquedaCodigosUCElementoDeProduccion"
                ref="inputcodigobarras"
                type="text"
                class="input-busquedaCodigos"
                :label="$t('common.barcode')"
                :placeholder="$t('common.barcode')"
                :value="valorCampoLectura"
                accept="number"
                @input="valorCampoLectura = $event.target.value"
              >
            </div>
          </f7-col>
        </f7-row>
      </form>
    </div>
    <!-- BUSQUEDA UNIDAD LOGISTICA -->
    <div v-show="readingMode === modosLectura.UNIDAD_CONTENEDORA">
      <p v-show="mostrarTitulo">
        {{
          $t('production.productionElement.searchByContainer.title', {
            text: textoBusqueda,
          })
        }}
      </p>
      <form
        class="from-busquedas"
        @submit.prevent="validarUnidadLogistica"
      >
        <f7-row>
          <f7-col width="20">
            <div class="div-modoInput">
              <div
                class="div-btnModoInput"
                @click="modoLectura = modosLectura.PARTIDA"
              >
                <img
                  class="img-btnModoInput"
                  alt="iconUnidad"
                  src="@/static/icons/ic_logistic_unit.svg"
                  width="50"
                  height="50"
                >
              </div>
            </div>
            <div class="div-btnInformacionCambioCirculo">
              <img
                class="img-btnCambioModo"
                alt="iconChange"
                src="@/static/icons/ic_exchange_arrows.svg"
                width="18"
                height="18"
              >
            </div>
          </f7-col>
          <f7-col width="80">
            <div class="div-campoDeEntrada">
              <input
                id="input-busquedaULUCElementoDeProduccion"
                ref="inputunidadlogistica"
                class="input-busquedaCodigos"
                :label="textoBusqueda"
                type="text"
                :placeholder="textoBusqueda"
                required=""
                clear-button=""
                :value="valorCampoLectura"
                @input="valorCampoLectura = $event.target.value"
              >
            </div>
          </f7-col>
        </f7-row>
      </form>
    </div>
    <!-- BUSQUEDA PARTIDA -->
    <div v-show="readingMode === modosLectura.PARTIDA">
      <p v-show="mostrarTitulo">
        {{ $t('production.productionElement.searchByBatch.title') }}
      </p>
      <form
        class="from-busquedas"
        @submit.prevent="validarPartida"
      >
        <f7-row>
          <f7-col width="20">
            <div class="div-modoInput">
              <div
                class="div-btnModoInput"
                @click="modoLectura = modosLectura.CODIGO"
              >
                <img
                  class="img-btnModoInput"
                  alt="iconPartida"
                  src="@/static/icons/ic_batch.svg"
                  width="50"
                  height="50"
                >
              </div>
            </div>
            <div class="div-btnInformacionCambioCirculo">
              <img
                class="img-btnCambioModo"
                alt="iconChange"
                src="@/static/icons/ic_exchange_arrows.svg"
                width="18"
                height="18"
              >
            </div>
          </f7-col>
          <f7-col width="80">
            <div class="div-campoDeEntrada">
              <input
                id="input-busquedaPCUCElementoDeProduccion"
                ref="inputpartida"
                class="input-busquedaCodigos"
                :label="$t('common.batch')"
                type="text"
                :placeholder="$t('common.batch')"
                required=""
                clear-button=""
                :value="valorCampoLectura"
                @input="valorCampoLectura = $event.target.value"
              >
            </div>
          </f7-col>
        </f7-row>
      </form>
    </div>
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import SoporteGeneral from '@/js/common/HICommonSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';

export default {
  name: 'UCProductionElement',
  components: {
    UCCodeScanner,

  },
  props: {
    activo: { type: Boolean, default: true },
    mostrarTitulo: { type: Boolean, default: true },
    restablecer: { type: Number, default: 0 }, // Con el canbio de valor se restablece el componente
    trabajarConNumerosDeSerie: { type: Boolean, default: false }, // Por defecto trabajara con UL
    autofocusOnInput: { type: Boolean, default: false },
    modoLecturaInit: { type: String, default: 'uc' },
  },

  data() {
    return {
      modosLectura: {
        CODIGO: 'Codigo',
        UNIDAD_CONTENEDORA: 'uc', // Unidad Logistica y Numeros De Serie
        PARTIDA: 'p',
      },
      modoLectura: '',
      valorCampoLectura: '', // Valor que contiene el input de elemento de producción
      valorBuscado: '',
      elementoDeProduccion: null, // Almacena el objeto elemento de producción una vez validado
      tipoLectura: null, //  Sera UNIDAD_CONTENEDORA o PARTIDA
      textoBusqueda: this.$t('common.logisticsUnit'), // Unidad logística o Numero de Serie

      // actionRecuperadoElementoVolcadoAbierto: false // Controla la apertura del action de recuperado de elementos volcados buscados.
    };
  },
  computed: {
    readingMode() {
      return this.modoLectura;
    },
  },

  watch: {
    activo(val) {
      if (val) {
        Log(this, this.activo.name);
        this.activarListener();
      } else {
        this.desactivarListener();
      }
    },
    restablecer() {
      this.restablecerControl();
    },
    trabajarConNumerosDeSerie(val) {
      if (val) {
        this.textoBusqueda = this.$t('production.productionElement.container.serialNumber');
      }
    },
  },
  created() {
    this.modoLectura = this.modoLecturaInit;
    this.activarListener();
  },
  mounted() {
    this.FocusOnInput();
  },
  beforeUnmount() {
    this.desactivarListener();
  },
  methods: {
    activarListener() {
      Log(this, this.activarListener.name);
      eventBus.on('lecturaDeCodigoTag', (codigoLeido) => {
        this.lecturaDeCodigoTagRealizada(codigoLeido);
      });
    },
    desactivarListener() {
      Log(this, this.desactivarListener.name);
      eventBus.off('lecturaDeCodigoTag');
    },
    CodeScannerRead(value) {
      Log(this, this.CodeScannerRead.name);
      this.valorCampoLectura = value;
      this.validarCodigo();
    },
    FocusOnInput() {
      Log(this, this.FocusOnInput.name);
      if (this.autofocusOnInput) {
        if (this.readingMode === this.modosLectura.UNIDAD_CONTENEDORA) {
          this.$refs.inputunidadlogistica.focus();
        }
        if (this.readingMode === this.modosLectura.CODIGO) {
          this.$refs.inputcodigobarras.focus();
        }
        if (this.readingMode === this.modosLectura.PARTIDA) {
          this.$refs.inputpartida.focus();
        }
      }
    },
    /** ** Método validarCodigo */
    validarCodigo() {
      Log(this, this.validarCodigo.name);
      // Quitamos el Foco del elemento input
      SoporteGeneral.EliminarFocoElementoActivo();
      const self = this;

      // var preloader = HiDialog.Preloader(true, 'Validando Codigo de Barras..');
      const preloaderTitle = this.$t('codeScanner.info.validatingBarcode');
      const preloaderCancelText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderTitle, preloaderCancelText);

      this.valorBuscado = this.valorCampoLectura;
      ConexionTA.callObteneElementoDeProduccionPorCodigoDeBarras(this.valorCampoLectura).then((result) => {
        if (result.Valor) {
          Log(this, `Tipo Codigo De Barras: ${result.TipoBusquedaEntidad}`);

          if (result.TipoBusquedaEntidad === 0) { // UnidadContenedora
            self.tipoLectura = self.modosLectura.UNIDAD_CONTENEDORA;
            self.elementoDeProduccion = result.UnidadContenedora;
          }
          if (result.TipoBusquedaEntidad === 1) { // Partida
            self.tipoLectura = self.modosLectura.PARTIDA;
            self.elementoDeProduccion = result.Partida;
          }
          if (result.EstaEnExistencias) {
            self.notificarElementoDeProduccionEstablecido();
          } else {
            self.notificarElementoDeProduccionEstablecidoSinExistencias();
          }
          self.restablecerControl();
          PreloaderGH(false);
        } else {
          PreloaderGH(false);
          this.restablecerControl();
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
        });
    },
    validarCodigoTag(codigoTag) {
      Log(this, this.validarCodigoTag.name);
      // Quitamos el Foco del elemento input
      SoporteGeneral.EliminarFocoElementoActivo();
      const self = this;

      // var preloader = HiDialog.Preloader(true, 'Validando Codigo de Barras..');
      const preloaderTitle = this.$t('codeScanner.info.validatingBarcode');
      const preloaderCancelText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderTitle, preloaderCancelText);

      this.valorBuscado = codigoTag;
      ConexionTA.callObteneElementoDeProduccionPorCodigoTag(codigoTag).then((result) => {
        if (result.Valor) {
          Log(this, `Tipo Codigo De Barras: ${result.TipoBusquedaEntidad}`);

          if (result.TipoBusquedaEntidad === 0) { // UnidadContenedora
            self.tipoLectura = self.modosLectura.UNIDAD_CONTENEDORA;
            self.elementoDeProduccion = result.UnidadContenedora;
          }
          if (result.TipoBusquedaEntidad === 1) { // Partida
            self.tipoLectura = self.modosLectura.PARTIDA;
            self.elementoDeProduccion = result.Partida;
          }
          if (result.EstaEnExistencias) {
            self.notificarElementoDeProduccionEstablecido();
          } else {
            self.notificarElementoDeProduccionEstablecidoSinExistencias();
          }
          self.restablecerControl();
          PreloaderGH(false);
        } else {
          PreloaderGH(false);
          this.restablecerControl();
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
        });
    },
    validarUnidadLogistica() {
      Log(this, this.validarUnidadLogistica.name);
      // Quitamos el Foco del elemento input
      SoporteGeneral.EliminarFocoElementoActivo();
      const self = this;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      const preloaderCancelText = this.$t('production.productionElement.validation.code.serialNumber.cancellationText');
      PreloaderGH(true, true, preloaderText, preloaderCancelText);

      this.valorBuscado = this.valorCampoLectura;
      ConexionTA.callObteneElementoDeProduccionPorIdentificadorNumeroSerie(this.valorCampoLectura).then((result) => {
        if (result.Valor) {
          self.elementoDeProduccion = result.UnidadContenedora;
          PreloaderGH(false);
          self.tipoLectura = self.modosLectura.UNIDAD_CONTENEDORA;
          if (result.EstaEnExistencias) {
            self.notificarElementoDeProduccionEstablecido();
          } else {
            this.notificarElementoDeProduccionEstablecidoSinExistencias();
          }
          self.restablecerControl();
        } else {
          PreloaderGH(false);
          this.restablecerControl();
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          LogError('error al validar unidad logistica', error);
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
        });
    },
    ProcesarEstadoUnidadContenedora(result) {
      Log(this, this.ProcesarEstadoUnidadContenedora.name);
      if (result.EstaEnExistencias) {
        this.tipoLectura = this.modosLectura.UNIDAD_CONTENEDORA;
        this.elementoDeProduccion = result.UnidadContenedora;
      } else {
        this.notificarElementoDeProduccionEstablecidoSinExistencias();
      }
    },
    procesarErrorBusquedaRecibido(result) {
      Log(this, this.procesarErrorBusquedaRecibido.name);
      Log(result);
      this.restablecerControl();
      Log(result);
      this.restablecerControl();
      if (result.Codigo === 600) {
        if (result.TipoEntidad === 'Partida') {
          this.tipoLectura = this.modosLectura.PARTIDA;
          this.elementoDeProduccion = {
            Id: result.IdEntidadCreada,
            IdentificadorUnicoCodigoDeBarras: this.valorBuscado,
          };
        }
        this.notificarElementoDeProduccionEstablecidoSinExistencias(); //  TODO
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      }
    },

    validarPartida() {
      Log(this, this.validarPartida.name);
      // Quitamos el Foco del elemento input
      SoporteGeneral.EliminarFocoElementoActivo();
      const self = this;
      PreloaderGH(true, true);
      this.valorBuscado = this.valorCampoLectura;
      ConexionTA.callObteneElementoDeProduccionPorCodigoPartida(this.valorCampoLectura).then((result) => {
        if (result.Valor) {
          self.elementoDeProduccion = JSON.parse(result.Mensaje);
          PreloaderGH(false);
          self.tipoLectura = self.modosLectura.PARTIDA;
          self.notificarElementoDeProduccionEstablecido();
          self.restablecerControl();
        } else {
          PreloaderGH(false);
          self.procesarErrorBusquedaRecibido(result);
        }
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
          LogError('error al validar partida', error);
        });
    },
    /** * notificarElementoDeProduccionEstablecido */
    notificarElementoDeProduccionEstablecido() {
      Log(this, this.notificarElementoDeProduccionEstablecido.name);
      eventBus.emit('elementoDeProduccionEstablecido', { ElementoProduccion: this.elementoDeProduccion, Tipo: this.tipoLectura, Existencias: true });
    },
    /** * notificarElementoDeProduccionEstablecido */
    notificarElementoDeProduccionEstablecidoSinExistencias() {
      Log(this, this.notificarElementoDeProduccionEstablecidoSinExistencias.name);
      eventBus.emit('elementoDeProduccionEstablecido', { ElementoProduccion: this.elementoDeProduccion, Tipo: this.tipoLectura, Existencias: false });
    },
    /** * restablecerControl */
    restablecerControl() {
      Log(this, this.restablecerControl.name);
      this.elementoDeProduccion = null;
      this.valorCampoLectura = '';
    },

    /**
     * @public
     * @returns {void}
     */
    lecturaDeCodigoDeBarrasRealizada(codigoLeido) {
      Log(this, this.lecturaDeCodigoDeBarrasRealizada.name);
      this.modoLectura = this.modosLectura.CODIGO;
      this.valorCampoLectura = codigoLeido;
      this.validarCodigo();
    },

    /** *     lecturaDeCodigoTagRealizada */
    lecturaDeCodigoTagRealizada(codigoLeido) {
      Log(this, this.lecturaDeCodigoTagRealizada.name);
      this.modoLectura = this.modosLectura.CODIGO;
      // this.valorCampoLectura = codigoLeido;
      this.validarCodigoTag(codigoLeido);
    },

  },
};
</script>

<style scoped>
.div-campoDeEntrada {
  background: #fff;
  margin-right: 18px;
  margin-left: 18px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  min-height: 60px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.input-busquedaCodigos {
  width: 100%;
  height: 100%;
  padding-left: 19px;
  padding-right: 19px;
  color: #24253da8;
  font-size: 17px;
  margin-top: 22px;
  margin-bottom: 16px;
}

.div-modoInput {
  margin-top: 16px;
  margin-bottom: 0;
}

.div-btnModoInput {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  margin-left: 15px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  height: 100%;
  width: 100%;
  min-height: 58px;
  box-shadow: 0 6px 10px #6666662b;
}

.div-btnInformacionCambioCirculo {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid var(--his-silver);
  background: var(--his-tierra-white);
  position: relative;
  left: 55%;
  top: -13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-btnModoInput {
  min-height: 36px;

  /* width: 45%; */
}

.img-btnCambioModo {
  width: 15px;
}
</style>
